<template>

  <v-tooltip
    open-delay=1000
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span v-on="on" v-if="enableToolTip">
        <v-textarea
          v-bind="computedProps"
          :placeholder="phtext"
          v-on="computedListeners">
          <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
            {{ label }}
            <span v-if="required" class="mandatory">必須</span>
          </template>
        </v-textarea>
      </span>
      <v-textarea
        v-else
        v-bind="computedProps"
        :placeholder="phtext"
        v-on="computedListeners">
        <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
          {{ label }}
          <span v-if="required" class="mandatory">必須</span>
        </template>
      </v-textarea>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextarea } from 'vuetify/lib'

/**
 * @file DDv2用テキストエリア
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須制御有無
 * @vue-prop {Number} [length=Number.MAX_SAFE_INTEGER] - 入力可能桁数
 * @vue-prop {String} [errorMessages=''] - 表示エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-textarea/
 * @example
 * <dd-text-area
 *   v-model="textValue"
 *   :required="true"
 * />
 */
export default {
  name: 'DdTextArea',
  extends: VTextarea,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能桁数
     */
    length: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * 追加プレースホルダ
     */
    appendPlaceHolder: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    phtext: '',
    invalidMessage: ''
  }),
  created () {
  },
  mounted () {
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage)
    this.phtext = this.length ? '@@length@@文字以内'.replace('@@length@@', this.length) : ' '
    if (![undefined, null, ''].includes(this.appendPlaceHolder)) {
      this.phtext = this.phtext + '\n' + this.appendPlaceHolder
    }
    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        outlined: true,
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
      this.$emit('blur', e)
    },
    onFocus: function (e) {
      this.$emit('blur', e)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.value,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          // this.$set(this, 'invalidMessage', ret)
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
</style>
